import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import Card from "../../components/Card";
import Grid, { Col, Row } from "../../components/Grid";
import { ProfileCardProps } from "./types";
import SectionLabel from "../SectionLabel";
import Button from "../Button";
import { getEmailLabel, getUsernameLabel } from "../../utils/common";

export const ProfileCard: FC<ProfileCardProps> = ({
  name,
  username,
  businessName,
  email,
  password,
  handleAction,
  brandCode,
  actionText,
  titleText,
  showPassword,
  canHandleAction = true,
  isShowEmail = false,
}) => {
  const { t } = useTranslation();
  const emailLabel = getEmailLabel(brandCode);
  const usernameLabel = getUsernameLabel(brandCode);

  return (
    <Card>
      <h2>{titleText}</h2>
      <Grid>
        <Row>
          <Col>
            <SectionLabel>{t("name")}</SectionLabel>
          </Col>
          <Col className="ams-col__value">
            <SectionLabel>{name || t("n/a")}</SectionLabel>
          </Col>
        </Row>
        {businessName && (
          <Row>
            <Col>
              <SectionLabel>{t("businessName")}</SectionLabel>
            </Col>
            <Col className="ams-col__value">
              <SectionLabel>{businessName}</SectionLabel>
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <SectionLabel>{t(usernameLabel)}</SectionLabel>
          </Col>
          <Col className="ams-col__value">
            <SectionLabel>{username || t("n/a")}</SectionLabel>
          </Col>
        </Row>
        {isShowEmail ? (
          <Row>
            <Col>
              <SectionLabel>{t(emailLabel)}</SectionLabel>
            </Col>
            <Col className="ams-col__value">
              <SectionLabel>{email || t("n/a")}</SectionLabel>
            </Col>
          </Row>
        ) : null}

        {showPassword ? (
          <Row>
            <Col>
              <SectionLabel>{t("password")}</SectionLabel>
            </Col>
            <Col className="ams-col__value">
              <SectionLabel>{password}</SectionLabel>
            </Col>
          </Row>
        ) : null}
      </Grid>
      {canHandleAction ? (
        <Button onClick={handleAction}>{actionText}</Button>
      ) : null}
    </Card>
  );
};
